module.exports = __webpack_public_path__ + "static/media/wish_XIII_cs.ed3b4fca.png";